import { ActionType, getType } from 'typesafe-actions';
import * as commonActions from '../actions/common';

export type CommonActions = ActionType<typeof commonActions>;

export type CommonState = Readonly<{
  showChatbot: boolean;
}>;

const initialCommonState: CommonState = {
  showChatbot: true,
};

export default function commonReducer(
  state = initialCommonState,
  action: CommonActions,
): CommonState {
  switch (action.type) {
    case getType(commonActions.toggleChatbot):
      return {
        ...state,
        showChatbot: action.payload,
      };
    default:
      return state;
  }
}
